import { groupBy, maxBy } from "lodash";

export const prepareData = list => {
  const filteredData = [];
  const groupedList = groupBy(list, "assigneeName");
  Object.keys(groupedList).forEach(item => {
    const lastItem = maxBy(groupedList[item], task => task.updatedAt);
    filteredData.push(lastItem);
  });
  return filteredData;
};
